import { render, staticRenderFns } from "./SiteConfiguration.vue?vue&type=template&id=5a57488b&scoped=true&"
import script from "./SiteConfiguration.vue?vue&type=script&lang=js&"
export * from "./SiteConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./SiteConfiguration.vue?vue&type=style&index=0&id=5a57488b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a57488b",
  null
  
)

export default component.exports